// extracted by mini-css-extract-plugin
export default {"background":"TitleBox_background__LI-2s","subtitle":"TitleBox_subtitle__OV-Z7"};